import {AutogenLayoutAssureAdvantageControl} from "./autogen/AutogenLayoutAssureAdvantageControl";
import {
    ChangeEvent, DataSource,
    DataSourceMode,
    LayoutProps,
    LookupModelSelectionEvent, TableRow,
    TableRowBeforeSaveEvent, Textbox
} from "@mcleod/components";
import {Api, ModelRow, ModelRowType} from "@mcleod/core";
import {CommonDialogs} from "@mcleod/common";

interface ControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class AssureAdvantageControl extends AutogenLayoutAssureAdvantageControl{

    private _vendorId: string;

    constructor(props?: Partial<ControlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId || "";
    }

    async onLoad() {
        this.mainDataSource.addAfterModeChangeListener((event) => {
            if (event.newMode === DataSourceMode.ADD && this.mainDataSource.activeRow) {
                this.activeRow.setValues(this.mainDataSource.activeRow.get("assure_advantage_default_values"));
            }
        });
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("vendor_id", vendorId);
            this.mainDataSource?.activeRow?.set("onboarding_username", this.mainDataSource.activeRow.get("account_id"));
            this.mainDataSource?.activeRow?.set("onboarding_password", this.mainDataSource.activeRow.get("account_password"));
            this.mainDataSource?.activeRow?.set("onboarding_server", this.mainDataSource.activeRow.get("server"));
            await this.mainDataSource.post();
            return true;
        } catch {
            return false;
        }
    }

    async switchIsActiveOnChange(event: ChangeEvent) {
        if (!event.userInitiatedChange || event.newValue !== true) return;

        const response = await Api.search("lme/powerbroker/get-update-default-vendor", {
            vendor: this._vendorId,
            monitoring_vendor: true,
        });

        if (!response.data[0]?.default_vendor_list) return;

        const userConfirmed = await this.confirmChangeActiveVendor(response.data[0].default_vendor_list,response.data[0].vendor);
        if (userConfirmed) {
            await Api.update("lme/powerbroker/get-update-default-vendor", {
                vendor: this._vendorId,
                monitoring_vendor: true,
            });
        } else {
            this.switchIsActive.checked = false;
        }
    }

    private async confirmChangeActiveVendor(defaultVendorList: any, vendor: any): Promise<boolean> {
        return await CommonDialogs.showYesNo(
            `Only one service provider can be active at a time. Would you like to activate ${vendor} and deactivate the following service provider? ${this.getDefaultVendorList(defaultVendorList)}`,
            "Change Active Vendor"
        );
    }

    private getDefaultVendorList(defaultVendorList: any): string {
        return "\n\n" + defaultVendorList.map((vendor: any) => vendor.vendor).join("\n");
    }

    tableAssureAdvantageEquipmentTypeMappingsBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        modelRow.set("code_type", "AAE");
    }

    textboxOrderTypeBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }

    textboxDisplayValueBeforeLookupModelSearch(event) {
        event.filter.applies_to = "L";
    }
}
